import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Button, ButtonToolbar, Popover} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import ProviderPicker from './ProviderPicker'
import {ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_UPDATED, sendAssociateProviderContactWithProviderCompanyCmd, updateAssociateProviderContactWithProviderCompanyCmd, loadContact} from '../actions'
import {AssociateProviderContactWithProviderCompanyCmd} from '../models'
import i18n from '../i18n'

class AssociateProviderContactWithProviderCompanyPopover extends Component {

    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch, contact} = this.props
        dispatch(updateAssociateProviderContactWithProviderCompanyCmd({providerCompanyUid: contact.providerCompany}))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.contact != this.props.contact) {
            const {dispatch, contact} = nextProps
            dispatch(updateAssociateProviderContactWithProviderCompanyCmd({providerCompanyUid: contact.providerCompany}))
        }
    }

    _sendCmd(action) {
        const {dispatch, onHide} = this.props
        return dispatch(sendAssociateProviderContactWithProviderCompanyCmd()).then(() => {
            return dispatch(loadContact())
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, onHide, form, cmd, ...others} = this.props

        return (
            <Popover
                bsClass='popover-lg popover'
                title={i18n.associateProvider}
                {...others}>
                <ProviderPicker split
                    {...form.providerCompanyUid()} />
                <ButtonToolbar>
                    <LoaderButton
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.save}
                    </LoaderButton>
                    <Button
                        bsSize='large'
                        onClick={onHide}>
                        {i18n.cancel}
                    </Button>
                </ButtonToolbar>
            </Popover>
        )
    }
}

AssociateProviderContactWithProviderCompanyPopover = connectForm({
    target: 'cmd',
    schema: AssociateProviderContactWithProviderCompanyCmd.schema,
    action: ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_UPDATED
})(AssociateProviderContactWithProviderCompanyPopover)

AssociateProviderContactWithProviderCompanyPopover = connect((state) => ({
    cmd: state.provider.associateProviderContactWithProviderCompanyCmd,
    contact: state.provider.contact.contact
}))(AssociateProviderContactWithProviderCompanyPopover)

export default AssociateProviderContactWithProviderCompanyPopover


// WEBPACK FOOTER //
// ./lib/provider/components/AssociateProviderContactWithProviderCompanyPopover.js